import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterCompanyNanoIdValue,
  UniversalFilterCompanyNanoIdModes,
  UniversalFilterCompanyNanoIdFilterState,
  UniversalFilterCompanyNanoIdOnChange
} from '../../UniversalFilterCompanyNanoId.types';
import { NanoID } from '../../../../../../../types';

interface UniversalFilterCompanyNanoIdFilterStateOptions {
  onChange: UniversalFilterCompanyNanoIdOnChange;
}

function useUniversalFilterCompanyNanoIdFilterState({
  onChange
}: UniversalFilterCompanyNanoIdFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterCompanyNanoIdFilterState) => void
  >(
    (filterState) => {
      const companyNanoIds = filterState?.companyNanoIds;

      if (
        filterState?.mode === UniversalFilterCompanyNanoIdModes.CONTAINS_ANY_OF
      ) {
        onChange(isEmpty(companyNanoIds) ? undefined : { in: companyNanoIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterCompanyNanoIdValue
    ) => UniversalFilterCompanyNanoIdFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue.in)) {
      return {
        mode: UniversalFilterCompanyNanoIdModes.CONTAINS_ANY_OF,
        companyNanoIds: filterValue.in as NanoID[]
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterCompanyNanoIdFilterState;
